<div class="row p-2 mb-3 align-items-center">
  <div class="col-12 col-md-7 text-start">
    <div class="page-title-heading">
      <div class="page-title-icon"><i class="fa-solid fa-file-lines"></i></div>
      <div>
        Modèle de livrable
        <div class="page-title-subheading">Modèles de documents générés</div>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-5 text-end">
    <app-header></app-header>
  </div>
</div>
   <div class="row">
    <div class="col-lg-12">
        <div class="card">
          
            <div class="card-body">
                  <div class="d-flex justify-content-between mb-5">
                    <div class="me-2">
                        <button *ngIf="buttonsPermission?.add" type="button" class="btn btn-danger btn-sm" (click)="add(addContent)">
                            <i class="fa-solid fa-plus me-2" aria-hidden="true"></i>Nouveau modèle
                            </button>
                    </div>
                    <div class=" " *ngIf="buttonsPermission">
                        <button *ngIf="selected_data && buttonsPermission.show"  (click)="show(showContent)" type="button" class="btn btn-outline-primary btn-sm btn-label waves-effect waves-light me-3">
                             <span>Consulter</span></button>
                        <button *ngIf="selected_data && buttonsPermission.edit" (click)="edit(editContent)" type="button"  class="btn btn-outline-warning btn-sm btn-label waves-effect waves-light me-3">
                           Editer</button>
                        <button *ngIf="selected_data && buttonsPermission.delete" (click)="delete()" type="button" class="btn btn-outline-danger btn-sm btn-label waves-effect waves-light me-3">
                             Supprimer</button>
                             <button *ngIf="selected_data && is_active!=null && !is_active" (click)="setStatus(1)" type="button" class="btn btn-outline-success btn-sm btn-label waves-effect waves-light me-3">
                                Activer</button>
                               <button  *ngIf="selected_data && is_active!=null && is_active" (click)="setStatus(0)" type="button" class="btn btn-outline-danger btn-sm btn-label waves-effect waves-light me-3">
                                Désactiver</button>
                    </div>

                    <div class="form-group ms-auto">
                        <label for=""> <strong>Rechercher:</strong> </label>
                        <input placeholder="Rechercher..." class="form-control form-control-sm" type="text" name="search_text" [(ngModel)]="search_text">
                    </div>
                </div>

                        <p>{{data!.length}} élément(s)</p>
                        <div class="table-responsive">
                        <table class="table table-striped table-hover table-borderless table-sm" >
                            <thead class="">
                                <tr>
                                    <th style="width: 10px;">#</th>
                                    <th>Libellé</th>
                                    <th>Statut</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr (click)="checked(d)" [class.table-active]="selected_data?.id === d.id" style="cursor: pointer;" *ngFor="let d of data | sampleSearch:search_text:'rooms' | paginate: {
                                id:'ngxP1',
                                itemsPerPage: pg.pageSize,
                                currentPage: pg.p,
                                totalItems: pg.total } ">
                                    <td>
                                        <div class="form-check mb-2">
                                            <input (click)="checked(d)" class="form-check-input" type="radio" [checked]="selected_data?.id === d.id" name="flexRadioDefault">
                                        
                                        </div>
                                    </td>
                                    <td>{{d.title}}</td>
                                    <td>
                                        <span *ngIf="d.is_active" class="badge bg-success">Actif</span>
                                        <span *ngIf="!d.is_active" class="badge bg-danger">Bloqué</span>

                                    </td>
                                </tr>
                            
                            </tbody>
                        </table>
                        </div>
                        <pagination-controls 
                        id="ngxP1"
                        (pageChange)="getPage($event)"
                      [maxSize]="9"
                      [directionLinks]="true"
                      [autoHide]="true"
                      [responsive]="true"
                      [previousLabel]="'Précédent'"
                      [nextLabel]="'Suivant'"
                      [screenReaderPaginationLabel]="'Pagination'"
                      [screenReaderPageLabel]="'page'"
                      [screenReaderCurrentLabel]="'Vous êtes sur la page'">
                     </pagination-controls>

            </div><!-- end card -->
        </div>
        <!-- end col -->
    </div>
    <!-- end col -->
</div>


<ng-template #addContent let-c="close" let-d="dismiss">
    <form #addForm="ngForm" (ngSubmit)="store(addForm.value)">
    <div class="modal-header">
      <h6 class="modal-title" id="modal-basic-title">Enregistrer un modèle de livrable </h6>
      <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
    </div>
    <div class="modal-body" >
        <div class="row mb-3" >
            <div class="container bg-info text-white">
                Inscirvez ces tags dans le contenu pour une insertion des vraies valeur par le système lors de la génération. 
                <ul>
                    <li><strong>[NOM_PRENOM_ELEVE]</strong>: indexe le nom et le(s) prénom(s) de l'élève</li>
                    <li><strong>[DATE_NAISSANCE_ELEVE]</strong>: indexe la date de naissance de l'élève</li>
                    <li><strong>[CLASSE_ELEVE]</strong>: indexe la classe de l'élève</li>
                    <li><strong>[ANNEE_ACADEMIQUE_ELEVE]</strong>: indexe l'année académique</li>
                    <li><strong>[DATE]</strong>: indexe la date de génération du document</li>
                </ul>
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">Titre du livrable <span class="text-danger ml-2">(*)</span></label>
                <input type="text" name="title" class="form-control" ngModel  required>
            </div>
        
            <div class=" form-group col-12 mb-3">
                <label for="">Contenu standard <span class="text-danger ml-2">(*)</span></label>
                <angular-editor name="text" [placeholder]="'Saisir le contenu du livrable'" ngModel required></angular-editor>
            </div>
        
         
        </div>
       
    </div>
    <div class="modal-footer">
      <button type="submit" class="btn btn-outline-dark" [disabled]="addForm.invalid"  >Enregistrer <app-loading [isVisible]="loading"></app-loading></button>
    </div>
</form>
  </ng-template>

  <ng-template #editContent let-c="close" let-d="dismiss">
    <form #editForm="ngForm" (ngSubmit)="update(editForm.value)">
    <div class="modal-header">
      <h6 class="modal-title" id="modal-basic-title">Modifier le modèle de livrable</h6>
      <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
    </div>
    <div class="modal-body" >
        <div class="container bg-info text-white">
            Inscirvez ces tags dans le contenu pour une insertion des vraies valeur par le système lors de la génération. 
            <ul>
                <li><strong>[NOM_PRENOM_ELEVE]</strong>: indexe le nom et le(s) prénom(s) de l'élève</li>
                <li><strong>[DATE_NAISSANCE_ELEVE]</strong>: indexe la date de naissance de l'élève</li>
                <li><strong>[CLASSE_ELEVE]</strong>: indexe la classe de l'élève</li>
                <li><strong>[ANNEE_ACADEMIQUE_ELEVE]</strong>: indexe l'année académique</li>
                <li><strong>[DATE]</strong>: indexe la date de génération du document</li>
            </ul>
        </div>
        <div class="row mb-3">
        
            <div class=" form-group col-12 mb-3">
                <label for="">Titre du livrable <span class="text-danger ml-2">(*)</span></label>
                <input type="text" name="title" class="form-control" [(ngModel)]="selected_data.title">
            </div> 
            <div class=" form-group col-12 mb-3">
                <label for="">Contenu standard <span class="text-danger ml-2">(*)</span></label>
                <angular-editor name="text" [placeholder]="'Saisir le contenu du livrable'" [(ngModel)]="selected_data.text" required></angular-editor>
            </div>
        </div>
       
    </div>
    <div class="modal-footer">
      <button type="submit" class="btn btn-outline-dark" [disabled]="editForm.invalid" >Sauvegarder <app-loading [isVisible]="loading"></app-loading></button>
    </div>
</form>
  </ng-template>

  <ng-template #showContent let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Détails des informations</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
      </div>

      <div class="modal-body">
        <div class="table-responsive table-card">
           <dl>
                <dt>Titre du modèle</dt>
                <dd>{{selected_data?.title}}</dd>
           </dl>
           <dl>
                <dt>Contenu du modèle</dt>
                <dd>
                    <div [innerHTML]="selected_data?.text"></div>
                </dd>
           </dl>
        </div>
      </div>
</ng-template>
